import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { Code2 } from "lucide-react";

import { PlaceholderPage } from "@/components/cinch/PlaceholderPage";
import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

function CodeBasePage() {
  return (
    <PlaceholderPage
      title="Code Base"
      description="Monitor the health and activity of every repository the company runs."
      icon={Code2}
      plannedCapabilities={[
        "Per-repo overview: branch state, open PRs, CI health",
        "Deploy + release timeline across services",
        "Stale-branch and abandoned-PR alerts",
        "Test coverage and lint debt trends",
      ]}
    />
  );
}

export const codeBaseModule: FeatureModule = {
  key: "code_base",
  nav: {
    label: "Code Base",
    icon: Code2,
    to: "/code-base",
    requires: "code_base.read",
    order: 40,
    group: "Monitors",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/code-base",
      component: guarded("code_base.read", CodeBasePage),
    }),
  ] as unknown as AnyRoute[],
};
